import { styled } from "styled-components";

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
